export default __webpack_public_path__ + "static/media/many_not_found.21ece07f.png";